import React, { Suspense } from "react";

export const LazyPopularGuidesPage: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <LazyPopularGuidesPageBase />
    </Suspense>
  );
};

const LazyPopularGuidesPageBase = React.lazy<React.ComponentType>(() =>
  import(
    /* webpackChunkName: "popular-guides-page" */ "./PopularGuidesPage"
  ).then((module) => {
    return {
      default: module.PopularGuidesPage,
    };
  })
);
